import React from 'react';
import '../styles/Andra.scss';


export default class IcyMatAI extends React.Component {
    render() {
        const id = Math.round(Math.random() * 1000000);
        const size = this.props.size === undefined ? '1em' : this.props.size;
        let deprecated = false;
        let internalStyles = {
            width: size,
            height: size,
            border: 'none',
            position: 'static',
            stroke: 'none'
        };

        if (this.props.visible !== undefined) {
            internalStyles.display = this.props.visible ? 'inline-block' : 'none';
        }

        if (this.props.deprecated !== undefined) {
            deprecated = true;
        } else {
            internalStyles.fontSize = 'calc(' + size + ' + 0.5em)';
            delete internalStyles.width;
            delete internalStyles.height;
        }

        const styles = {...internalStyles, ...this.props.style}

        return (
            <a href="https://ai.icymat.com" target="_blank">
                {deprecated ?
                    <svg xmlns="http://www.w3.org/2000/svg"
                         style={styles}
                         width="6.94444in" height="6.94444in"
                         viewBox="0 0 500 500">
                        <defs>
                            <linearGradient id={'ai-gradient-' + id} gradientTransform="rotate(45)">
                                <stop stopColor="#ffa100" offset="0%">
                                    <animate attributeName="stop-color" values="#ffa100; #ab00ff; #ffa100" dur="5s"
                                             repeatCount="indefinite"/>
                                </stop>
                                <stop stopColor="#ff6400" offset="50%">
                                    <animate attributeName="stop-color" values="#ff6400; #ab00ff; #ff6400" dur="3s"
                                             repeatCount="indefinite"/>
                                </stop>
                                <stop stopColor="#ab00ff" offset="100%">
                                    <animate attributeName="stop-color" values="#ab00ff; #ff6400; #ab00ff" dur="2s"
                                             repeatCount="indefinite"/>
                                </stop>
                            </linearGradient>
                        </defs>
                        <path id="ai-path-1"
                            fill={'url(#ai-gradient-' + id + ')'} d="M 469.00,0.00
                                C 469.69,5.12 464.19,12.44 461.78,17.00
                                461.78,17.00 443.25,54.00 443.25,54.00
                                424.51,91.48 400.96,144.65 390.87,185.00
                                390.87,185.00 388.40,196.00 388.40,196.00
                                384.76,214.20 380.85,248.32 408.00,249.00
                                408.00,249.00 408.00,251.00 408.00,251.00
                                380.76,251.68 384.76,285.82 388.40,304.00
                                388.40,304.00 390.87,315.00 390.87,315.00
                                401.27,356.62 423.97,407.44 443.25,446.00
                                443.25,446.00 462.31,484.00 462.31,484.00
                                464.72,488.46 469.69,494.84 469.00,500.00
                                442.14,455.24 397.17,388.34 361.00,352.00
                                349.15,340.09 335.10,326.80 320.00,319.25
                                312.48,315.49 304.54,312.50 296.00,314.53
                                287.49,316.56 285.39,322.42 279.00,326.00
                                281.13,321.05 284.22,315.55 283.78,310.00
                                283.20,302.75 277.45,295.98 272.00,291.67
                                262.09,283.84 245.20,277.33 233.00,273.86
                                194.58,262.93 155.58,258.62 116.00,254.83
                                91.69,252.51 67.45,251.00 43.00,251.00
                                43.00,251.00 43.00,249.00 43.00,249.00
                                74.17,249.00 105.01,246.27 136.00,243.17
                                167.06,240.06 201.11,235.28 231.00,226.28
                                244.84,222.11 263.37,215.80 274.00,205.91
                                280.00,200.32 284.50,194.59 283.90,186.00
                                283.56,181.05 280.42,177.26 281.00,173.00
                                284.07,177.05 287.46,181.12 292.00,183.59
                                299.77,187.81 308.43,185.76 316.00,182.22
                                329.02,176.13 340.65,166.86 351.00,156.96
                                387.60,121.95 425.65,67.93 453.31,25.00
                                453.31,25.00 469.00,0.00 469.00,0.00 Z" />
                    </svg>
                :
                    <span className="icymat ai" style={styles} />
                }
            </a>
        );
    }
}
